import React from "react";

import "./HeroSection.css";

export const HeroSection = () => {
  return (
    <>
      <div className="hero-heading-container">
        <h1 className="hero-title">Top selling</h1>
        <h2 className="hero-subtitle">
          Step into fashion-forward confidence with our chic and curated
          selection of shoes at TheWAlk, where comfort meets style in every
          pair.
        </h2>
      </div>
    </>
  );
};
